import { useRecoilValue } from "recoil";
import { userState } from "../../../states/user";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon-arrowRight.svg";
import { MainProfileImg } from "../../atoms/MainProfileImg";
import { MoreInfo } from "../../molcules/MoreInfo";
import { MoreNavigation } from "../../molcules/MoreNavigation";
import * as S from "./MorePageContent.styles";
import { useState } from "react";
import LogoutModal from "../../molcules/Modal/LogoutModal";
import { Link } from "react-router-dom";

interface MorePageContentType {
  userTransportData: any;
}

export const MorePageContent = ({ userTransportData }: MorePageContentType) => {
  const user = useRecoilValue(userState);
  const [isModal, setIsModal] = useState<boolean>(false);

  return (
    <S.MoreContent>
      <S.MoreContentHeader>
        <Link to="/myinfo">
          <div>
            <S.MainProfileSection>
              {!user?.profileImg ? (
                <MainProfileImg width={75} height={75} />
              ) : (
                <S.MainProfileBox>
                  <img
                    src={`${process.env.REACT_APP_API_HOST}${user.profileImg.imageUrl}`}
                    alt="profile"
                  />
                </S.MainProfileBox>
              )}
              <S.ProfileTxtBox>
                <S.UserAuthSpan>기사회원</S.UserAuthSpan>
                <S.UserStatusBox>
                  {user?.username}
                  <IconArrow width={30} height={30} fill="#1D4ED7" />
                </S.UserStatusBox>
                <S.UserNumberBox>{user?.profile?.phoneNumber}</S.UserNumberBox>
              </S.ProfileTxtBox>
            </S.MainProfileSection>
          </div>
        </Link>
        {/* 운송/배차/요금 횟수 컴포넌트  */}
        <MoreInfo userTransportData={userTransportData} />
      </S.MoreContentHeader>
      <MoreNavigation setIsModal={setIsModal} />
      {isModal && <LogoutModal setIsModal={setIsModal} />}
    </S.MoreContent>
  );
};
